import "./SignIn.scss";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { images } from "../../utils/images";
import { motion } from "framer-motion";
import TextError from "../../components/textError/TextError";
import { Fragment, useContext, useState } from "react";
import WebLayout from "../../components/weblayout/WebLayout";
import { NavLink, useNavigate } from "react-router-dom";
import { IoEyeSharp } from "react-icons/io5";
import { FaEyeSlash } from "react-icons/fa";
import { baseUrl, userLogin } from "../../utils/apiData";
import axios from "axios";
import { webContext } from "../../webContext/WebContext";
import _ from "lodash";
import GoogleLoginBtn from "./googleLoginBtn/GoogleLoginBtn";
import LinkedinAuthBtn from "./linkedinAuth/LinkedInAuth";

const SignIn = () => {
  const { toastError, toastSuccess } = useContext(webContext);
  const [type, setType] = useState(false);
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object({
    email: Yup.string()
      .email("invalid email format")
      .required("Email Required"),
    password: Yup.string().required("Password Required"),
  });

  const onSubmit = (values, { resetForm }) => {
    signInApi(values);
    resetForm();
  };

  const signInApi = async (values) => {
    setLoader(true);
    try {
      const res = await axios.post(`${baseUrl}/${userLogin}`, { ...values });
      if (res?.data?.success) {
        setLoader(false);
        localStorage.setItem("token", res?.data?.data?.token);
        localStorage.setItem("cart", res?.data?.data?.user?.is_cart);
        localStorage.setItem("name", res?.data?.data?.user.name);

        toastSuccess(res?.data?.message || "Login Successful!");
        navigate("/auth/home");
      } else {
        toastError(res?.data?.message || "Login Failed!");
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.error(error);
      toastError(error?.response?.data?.message || "Something went wrong!");
    }
  };

  // Linkedin Process

  return (
    <WebLayout>
      <section className="sign_up p_b">
        <div className="content_wrap">
          <div className="bi_sec">
            <div className="img_wraper p_t p_b">
              <motion.img
                initial={{ opacity: 0, scale: 0 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1, ease: "easeInOut", delay: 0.1 }}
                src={images.loginBanner}
                alt="Illustration of a hand holding a smartphone with an interface displaying user profile and social media icons hovering above the screen."
              />
            </div>
            <div className="form_wraper p_t p_b">
              <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
              >
                <Form>
                  <div className="title">
                    <motion.h3
                      initial={{ opacity: 0, translateY: 60 }}
                      whileInView={{ opacity: 1, translateY: 0 }}
                      transition={{ duration: 0.6, ease: "easeInOut" }}
                    >
                      Hi!
                    </motion.h3>

                    <motion.p
                      initial={{ opacity: 0, translateY: 60 }}
                      whileInView={{ opacity: 1, translateY: 0 }}
                      transition={{
                        duration: 0.6,
                        ease: "easeInOut",
                        delay: 0.2,
                      }}
                    >
                      Welcome back
                    </motion.p>
                  </div>

                  <motion.div
                    initial={{ opacity: 0, translateY: 60 }}
                    whileInView={{ opacity: 1, translateY: 0 }}
                    transition={{
                      duration: 0.6,
                      ease: "easeInOut",
                      delay: 0.1,
                    }}
                    className="field_wrap"
                  >
                    <label>Email</label>
                    <Field
                      type="text"
                      placeholder="e.g. email@gmail.com"
                      id="email"
                      name="email"
                      autoComplete="off"
                    />
                    <ErrorMessage name="email" component={TextError} />
                  </motion.div>

                  <motion.div
                    initial={{ opacity: 0, translateY: 60 }}
                    whileInView={{ opacity: 1, translateY: 0 }}
                    transition={{
                      duration: 0.6,
                      ease: "easeInOut",
                      delay: 0.2,
                    }}
                    className="field_wrap"
                  >
                    <label>Password</label>
                    <div className="password_wrap">
                      <Field
                        type={type ? "text" : "password"}
                        placeholder="Password"
                        id="password"
                        name="password"
                        autoComplete="off"
                      />
                      <button type="button" onClick={() => setType(!type)}>
                        {type ? <FaEyeSlash /> : <IoEyeSharp />}
                      </button>
                    </div>
                    <ErrorMessage name="password" component={TextError} />
                  </motion.div>
                  <motion.p
                    initial={{ opacity: 0, translateY: 60 }}
                    whileInView={{ opacity: 1, translateY: 0 }}
                    transition={{
                      duration: 0.6,
                      ease: "easeInOut",
                      delay: 0.3,
                    }}
                    className="forgot"
                  >
                    <NavLink to="/forgotpassword">Forgot Password?</NavLink>
                  </motion.p>

                  <motion.button
                    initial={{ opacity: 0, translateY: 60 }}
                    whileInView={{ opacity: 1, translateY: 0 }}
                    transition={{
                      duration: 0.6,
                      ease: "easeInOut",
                      delay: 0.4,
                    }}
                    type="submit"
                    className="submit_btn"
                  >
                    {loader ? "Loading..." : "Log In"}
                  </motion.button>
                </Form>
              </Formik>
              <div className="divider">
                <p>OR</p>
              </div>
              <div className="or_way">
                <GoogleLoginBtn signInApi={signInApi} />

                <Fragment>
                  <LinkedinAuthBtn />
                </Fragment>
              </div>

              <motion.p
                initial={{ opacity: 0, translateY: 60 }}
                whileInView={{ opacity: 1, translateY: 0 }}
                transition={{ duration: 0.6, ease: "easeInOut", delay: 0.3 }}
                className="suggestion"
              >
                Don’t have an account? <NavLink to="/signup">Sign Up</NavLink>
              </motion.p>
            </div>
          </div>
        </div>
      </section>
    </WebLayout>
  );
};

export default SignIn;
